export default "__VITE_ASSET__Bcw1_Qxi__"